export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

/** 各 Tab 顶部说明 Affix 偏移，与主 Tab 栏高度对齐 */
export const STICKY_ALERT_OFFSET_TOP = 46;

export const LIST_TYPE = {
    LIST_BAN: 'LIST_BAN',
    UNLIST_BAN: 'UNLIST_BAN',
};

export const BAN_ON_SOURCE = {
    MANUAL_ADD: 'MANUAL_ADD',
    MANUAL_UNLIST: 'MANUAL_UNLIST',
    SCHEDULE: 'SCHEDULE',
    MIGRATE_BLACK: 'MIGRATE_BLACK',
    MIGRATE_MANUAL: 'MIGRATE_MANUAL',
};

export const BAN_ON_SOURCE_OPTIONS = [
    { value: BAN_ON_SOURCE.MANUAL_ADD, label: '运营添加' },
    { value: BAN_ON_SOURCE.MANUAL_UNLIST, label: '人工下架' },
    { value: BAN_ON_SOURCE.SCHEDULE, label: '活动定时' },
    { value: BAN_ON_SOURCE.MIGRATE_BLACK, label: '迁移自黑名单' },
    { value: BAN_ON_SOURCE.MIGRATE_MANUAL, label: '迁移自人工下架标记' },
];

export const getBanOnSourceLabel = (value?: string) => {
    const found = BAN_ON_SOURCE_OPTIONS.find((item) => item.value === value);
    return found ? found.label : value || '-';
};

/** 禁止下架名单列表「标注」列固定文案 */
export const BAN_OFF_LIST_TAG = '无货仍展示、前台可搜索';

export const SCHEDULE_STATUS = {
    WAIT_START: 'WAIT_START',
    RUNNING: 'RUNNING',
    FINISHED: 'FINISHED',
    CANCELLED: 'CANCELLED',
    PARTIAL_FAIL: 'PARTIAL_FAIL',
};

export const SCHEDULE_STATUS_OPTIONS = [
    { value: SCHEDULE_STATUS.WAIT_START, label: '待开始' },
    { value: SCHEDULE_STATUS.RUNNING, label: '进行中' },
    { value: SCHEDULE_STATUS.FINISHED, label: '已完成' },
    { value: SCHEDULE_STATUS.CANCELLED, label: '已取消' },
    { value: SCHEDULE_STATUS.PARTIAL_FAIL, label: '部分失败' },
];

export const LOG_ACTION = {
    AUTO_LIST: 'AUTO_LIST',
    AUTO_UNLIST: 'AUTO_UNLIST',
    CD_START: 'CD_START',
    CD_CANCEL: 'CD_CANCEL',
};

export const LOG_ACTION_OPTIONS = [
    { value: LOG_ACTION.AUTO_LIST, label: '自动上架' },
    { value: LOG_ACTION.AUTO_UNLIST, label: '自动下架' },
    { value: LOG_ACTION.CD_START, label: '开始倒计时' },
    { value: LOG_ACTION.CD_CANCEL, label: '取消倒计时' },
];

export const LOG_RESULT = {
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
};

export const LOG_RESULT_OPTIONS = [
    { value: LOG_RESULT.SUCCESS, label: '成功' },
    { value: LOG_RESULT.FAIL, label: '失败' },
];

export const PENDING_STATUS = {
    RUNNING: 'RUNNING',
    CANCELLED: 'CANCELLED',
    EXECUTED: 'EXECUTED',
};

export const PENDING_STATUS_OPTIONS = [
    { value: PENDING_STATUS.RUNNING, label: '进行中' },
    { value: PENDING_STATUS.CANCELLED, label: '已取消' },
    { value: PENDING_STATUS.EXECUTED, label: '已执行' },
];

export const AUTO_ON_CONDITIONS = [
    { key: '1', cond: '当前状态', req: '下架' },
    {
        key: '2',
        cond: '商品品类',
        req:
            '翡翠(11)、和田玉(12)、其他玉石(13)、贵金属(16)、钻石(17)、黄金(18)、腕表(19)、奢箱包(20)、奢珠宝(21)、奢配件(24)、琥珀(29)、珍珠(30)、红蓝绿宝石(33)、其他宝石(34)',
    },
    { key: '3', cond: '商品类型', req: '成品' },
    { key: '4', cond: '可售库存', req: '≥ 1' },
    { key: '5', cond: '图片', req: '按品真阁有图规则判定为有图（见下方「怎样算有图」）' },
    { key: '6', cond: '是否支持预售', req: '不支持' },
    { key: '7', cond: '禁止上架名单', req: '所属 SPU 与该 SKU 都不在禁止上架名单' },
];

export const IMAGE_RULES = [
    {
        key: '1',
        system: '品真阁图',
        hasImage: '电商图 > 0；或电商图为 0，但按下表品类组命中推广图',
        noImage: '电商图为 0，且未命中对应品类组的推广图条件',
    },
];

export const PROMO_IMAGE_RULES = [
    {
        key: '1',
        group: '珠宝与贵金属',
        categories:
            '翡翠(11)、和田玉(12)、其他玉石(13)、贵金属(16)、钻石(17)、黄金(18)、琥珀(29)、珍珠(30)、红蓝绿宝石(33)、其他宝石(34)',
        rule: 'SPU 推广图 > 0，或 SKN 推广图 > 0（不按等级分流）',
    },
    {
        key: '2',
        group: '二手奢',
        categories: '腕表(19)、奢箱包(20)、奢珠宝(21)、奢配件(24)',
        rule: 'N 级（含等级为空）只看 SPU 推广图 > 0；非 N 级只看 SKN 推广图 > 0',
    },
];

export const AUTO_OFF_PATH1 = [
    {
        key: '1',
        item: '触发条件',
        desc: '已上架 + 可售库存 = 0 + 有图 + 所属 SPU 与该 SKU 都不在禁止下架名单',
    },
    { key: '2', item: '目的', desc: '下店锁库存期间用户仍可浏览；库存解锁后可正常购买' },
    { key: '3', item: '执行', desc: '创建待下架倒计时；开始时间起满 24 小时后自动下架' },
    { key: '4', item: '取消倒计时', desc: '可售库存 ≥ 1 → 取消倒计时，保持上架' },
    { key: '5', item: '加速下架', desc: '当前图片体系变为无图 → 立即下架，并取消倒计时' },
];

export const AUTO_OFF_PATH2 = [
    { key: '1', item: '触发条件', desc: '已上架 + 可售库存 = 0 + 无图' },
    { key: '2', item: '执行', desc: '立即下架，不进入倒计时' },
];

export const MANUAL_RULES = [
    {
        key: '1',
        item: '人工下架',
        desc:
            '下架商品，并按所选粒度（SPU 或 SKU）写入禁止上架名单；说明默认「人工下架，禁止自动上架」。不允许只下架、不入名单。',
    },
    {
        key: '2',
        item: '人工上架硬门禁',
        desc:
            '须同时满足：有图、非预售、品类适用。允许可售库存为 0。无图、预售或品类不适用时直接拦截。',
    },
    {
        key: '3',
        item: '命中禁止上架名单',
        desc:
            '须先确认，再移出挡住本次上架的禁止上架名单记录（当前 SKU，以及所属 SPU 如有），然后上架；取消则不上架，也不改名单。',
    },
    {
        key: '4',
        item: '零库存人工上架',
        desc:
            '若所属 SPU 与该 SKU 都不在禁止下架名单，确认后按 SPU 加入禁止下架名单再上架；已在名单则直接上架。',
    },
    {
        key: '5',
        item: '可售库存恢复',
        desc: '不在禁止上架名单，且满足全部自动上架条件 → 立即自动上架；仍在名单则不自动上架。',
    },
];

export const BAN_ON_SPU_MOCK = [
    {
        id: 'ban-on-spu-1',
        code: 'SPUA18006900',
        name: 'Gucci（古驰）单肩包',
        remark: '活动前预热，到点自动上架',
        source: '活动定时',
        creator: '1001-超级管理员',
        createTime: '2026-08-18 10:41:29',
    },
    {
        id: 'ban-on-spu-2',
        code: 'SPUA18006901',
        name: 'Fendi（芬迪）单肩包',
        remark: '运营控场，整 SPU 禁止自动上架',
        source: '运营添加',
        creator: '1002-运营小王',
        createTime: '2026-07-01 10:20:00',
    },
    {
        id: 'ban-on-spu-3',
        code: 'SPUA18006903',
        name: 'Bvlgari（宝格丽）单肩包',
        remark: 'SPU 级禁止自动上架',
        source: '运营添加',
        creator: '1001-超级管理员',
        createTime: '2026-07-03 09:30:00',
    },
    {
        id: 'ban-on-spu-4',
        code: 'SPUA18006904',
        name: '劳力士间金男表',
        remark: '禁止自动上架；同 SPU 另在禁止下架名单',
        source: '运营添加',
        creator: '1003-运营小李',
        createTime: '2026-07-04 14:00:00',
    },
];

export const BAN_OFF_SPU_MOCK = [
    {
        id: 'ban-off-spu-1',
        code: 'SPUA18006904',
        name: '劳力士间金男表',
        remark: '爆款无货仍展示、前台可搜索',
        creator: '1001-超级管理员',
        createTime: '2026-07-02 09:15:00',
    },
    {
        id: 'ban-off-spu-2',
        code: 'SPUA18006909',
        name: 'Gucci（古驰）单肩包',
        remark: '仅禁自动下架，可自动上架',
        creator: '1002-运营小王',
        createTime: '2026-07-07 12:00:00',
    },
    {
        id: 'ban-off-spu-3',
        code: 'SPUA18006884',
        name: '劳力士间金男表',
        remark: '爆款无货仍展示、前台可搜索',
        creator: '1001-超级管理员',
        createTime: '2026-07-02 09:15:00',
    },
];

export const SCHEDULE_SPU_MOCK = [
    {
        id: 'sch-1',
        name: '古驰包预热上架',
        summary: '1 个：SPUA18006900',
        onTime: '2026-08-21 10:00:00',
        offTime: '2026-08-28 22:00:00',
        status: '待开始',
        creator: '1002-运营小王',
        createTime: '2026-08-17 09:30:00',
        dim: 'SPU',
    },
    {
        id: 'sch-2',
        name: '芬迪联名取消档期',
        summary: '1 个：SPUA18006901',
        onTime: '2026-08-20 12:00:00',
        offTime: '2026-08-25 20:00:00',
        status: '已取消',
        creator: '1001-超级管理员',
        createTime: '2026-08-16 16:00:00',
        dim: 'SPU',
    },
    {
        id: 'sch-3',
        name: '双 SPU 定时上架',
        summary: '2 个：SPUA18006903、SPUA18006904',
        onTime: '2026-08-15 09:00:00',
        offTime: '—',
        status: '部分失败',
        creator: '1003-运营小李',
        createTime: '2026-08-14 10:00:00',
        dim: 'SPU',
    },
    {
        id: 'sch-4',
        name: '爱马仕整 SPU 控场',
        summary: '1 个：SPUA18006902',
        onTime: '2026-08-13 10:00:00',
        offTime: '2026-08-22 18:00:00',
        status: '进行中',
        creator: '1003-运营小李',
        createTime: '2026-08-12 14:00:00',
        dim: 'SPU',
    },
    {
        id: 'sch-5',
        name: '古驰箱包周末闪购',
        summary: '1 个：SPUA18006909',
        onTime: '2026-08-06 09:00:00',
        offTime: '2026-08-13 21:00:00',
        status: '已完成',
        creator: '1002-运营小王',
        createTime: '2026-08-04 11:00:00',
        dim: 'SPU',
    },
];

export const LOG_MOCK = [
    {
        id: 'log-1',
        sku: 'SKUGS00652812',
        spu: 'SPUA18006912',
        action: '取消倒计时',
        reason: '白名单变更重算',
        before:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        executeTime: '2026-08-18 10:41:29',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-2',
        sku: 'SKUGS00652815',
        spu: 'SPUA18006911',
        action: '取消倒计时',
        reason: '白名单变更重算',
        before:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        executeTime: '2026-08-18 10:41:29',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-3',
        sku: 'SKUGS00652815',
        spu: 'SPUA18006911',
        action: '取消倒计时',
        reason: '白名单变更重算',
        before:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 名见图 / 名见图2 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        executeTime: '2026-08-18 10:41:29',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-4',
        sku: 'SKUGS00652801',
        spu: 'SPUA18006900',
        action: '取消倒计时',
        reason: '白名单变更重算',
        before:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        executeTime: '2026-08-18 10:41:29',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-5',
        sku: 'SKUGS00652801',
        spu: 'SPUA18006900',
        action: '取消倒计时',
        reason: '白名单变更重算',
        before:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图2 / SPU推广图1 / SKN推广图1 / 命中禁止上架名单',
        executeTime: '2026-08-18 10:41:29',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-6',
        sku: 'SKUGS00652801',
        spu: 'SPUA18006900',
        action: '自动上架',
        reason: '满足自动上架条件',
        before:
            '下架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图0 / SPU推广图0 / SKN推广图0 / 未命中禁止上架名单',
        after:
            '上架 / 库存2 / 品真阁图 / 等级空 / 名见图0 / 电商图1 / 中台图0 / SPU推广图0 / SKN推广图0 / 未命中禁止上架名单',
        executeTime: '2026-07-10 09:00:00',
        result: '成功',
        failReason: '-',
    },
    {
        id: 'log-7',
        sku: 'SKUGS00652804',
        spu: 'SPUA18006904',
        action: '取消倒计时',
        reason: '命中禁止下架名单，取消倒计时',
        before:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图2 / 中台图0 / SPU推广图0 / SKN推广图0 / 命中禁止上架名单',
        after:
            '上架 / 库存0 / 品真阁图 / 等级空 / 名见图0 / 电商图2 / 中台图0 / SPU推广图0 / SKN推广图0 / 命中禁止上架名单',
        executeTime: '2026-07-10 10:30:00',
        result: '成功',
        failReason: '-',
    },
];

export const PENDING_MOCK = [
    {
        id: 'pending-1',
        sku: 'SKUGS00652810',
        spu: 'SPUA18006910',
        name: 'Louis Vuitton（路易威登）单肩包',
        startTime: '2026-08-10 12:00:00',
        expireTime: '2026-08-11 12:00:00',
        remain: '已到期',
        status: '进行中',
        cancelReason: '-',
    },
];
